import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import Loader from '../../../Components/Utility/Loader/Loader';
import './Status.css';
import * as action from '../Store/SystemMasters.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function StatusSettings({ onOpen, title, handleClose, statusCards, handleAdd, setStatusCards, docId }) {
  const { t } = useTranslation('common');
  const rountShape = ' rount-shape ';
  const apiTitle = 'supplier-status-master';
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const [shouldShowDelete, setShouldShowDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);

  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
    UserDetails: { userInfo },
  } = reducer;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const loggedInUserId = userInfo.userId;

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'placement', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'placement', 'addEdit');

  const handleChanged = (e, i) => {
    const value = e.target.value.trimStart().slice(0, 50);

    const statusData = [...statusCards];
    statusData[i] = {
      ...statusData[i],
      name: value,
      isEmpty: value === '',
    };
    const dataArray = [...statusData];
    setStatusCards(dataArray);
  };
  const handleDelete = async () => {
    if (deleteId) {
      setIsLoadingConf(true);
      const supplierStatusMasterParams = {
        loggedInUserId,
        supplierStatusId: deleteId,
        title: apiTitle,
      };
      await dispatch(action.deleteFromSystemMasters(supplierStatusMasterParams, t));
      setIsLoadingConf(false);
      setShouldShowDelete(false);
      const ssParams = {
        loggedInUserId,
      };
      const res = await dispatch(action.getSupplierStatusDetails(ssParams));
      if (res?.data) {
        const filteredData = res?.data?.filter((prop) => prop?.docId === docId);
        setStatusCards(filteredData);
        if (filteredData?.length === 0) {
          setStatusCards((prev) => [...prev, { _id: '', name: '' }]);
        }
      }
    }
  };
  const deleteAction = (id) => {
    if ((typeof id === 'number' || id === '') && statusCards?.length > 1) {
      statusCards?.splice(id, 1);
      setStatusCards([...statusCards]);
    }
    if (id !== '' && typeof id !== 'number') {
      setDeleteId(id);
      setShouldShowDelete((prev) => !prev);
    }
  };
  const activeAction = (id) => {
    setShowConfirmation((prev) => !prev);
    setDeleteId(id);
  };

  const handleActiveInactive = async () => {
    if (deleteId) {
      setIsLoadingConf(true);
      {
        let ssm = {};
        statusCards?.forEach((ele) => {
          if (ele._id === deleteId) {
            ele.isActive = !ele.isActive;
            const data = {
              ...ele,
              loggedInUserId,
              title: apiTitle,
            };
            ssm = data;
          }
        });
        await dispatch(action.setActiveInactive(ssm, t));
      }

      setIsLoadingConf(false);
      setShowConfirmation(false);

      setStatusCards([...statusCards]);
    }
  };

  const renderTooltip = (props, text) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );

  const checkDuplicate = (name) => {
    return statusCards?.find((item) => item._id && item.name.toLowerCase() === name.toLowerCase());
  };

  const isDisable = () => {
    // Check for empty names
    const hasEmptyName = statusCards?.some((item) => item?.name === '');
    if (hasEmptyName) {
      return true;
    }

    // Check for duplicates
    const nameCounts = statusCards?.reduce((acc, item) => {
      acc[item.name] = (acc?.[item?.name] || 0) + 1;
      return acc;
    }, {});

    return Object.values(nameCounts).some((count) => count > 1);
  };

  const handleClick = async () => {
    setIsLoading(true);

    if (!isEmpty(statusCards)) {
      const emptyField = await statusCards?.filter((pmitem) => pmitem.name === null || pmitem.name === '');

      if (isEmpty(emptyField)) {
        const data = statusCards?.map((ssobj) => {
          return { ...ssobj, name: ssobj?.name?.trim(), docId };
        });
        const params = {
          title: apiTitle,
          loggedInUserId,
          names: JSON.stringify(data),
        };

        await dispatch(action.saveToSystemMaster(params, t));
        const payload = {
          loggedInUserId,
        };
        const res = await dispatch(action.getSupplierStatusDetails(payload));
        if (res?.data) {
          const filteredData = res?.data?.filter((prop) => prop?.docId === docId);
          setStatusCards(filteredData);
          handleClose();
        }
        // post API
      } else {
        const newState = statusCards.map((pmObj) => (pmObj?.name === '' || pmObj.name === null ? { ...pmObj, isEmpty: true } : pmObj));
        setStatusCards(newState);
      }
    }
    setIsLoading(false);
  };

  const handleStatusColor = (i, status) => {
    statusCards?.forEach((ele, index) => {
      if (index === i) {
        ele.statusColor = status;
      }
    });
    setStatusCards([...statusCards]);
  };

  return (
    <div>
      <Modal show={onOpen} backdrop="static" className="custom-modal modal-medium" aria-labelledby="contained-modal-title-center" onHide={handleClose}>
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title id="contained-modal-title-vcenter">
              <span>{title}</span>
            </Modal.Title>
            <span onClick={handleAdd} className="icon-add add-status-icon cursor-pointer" />
          </div>
        </Modal.Header>
        <Modal.Body className="master-accordian">
          {isLoading ? (
            <Loader />
          ) : (
            <div className="card-body status-modal-body">
              <ul>
                {statusCards?.map((item, index) => {
                  return (
                    <div key={item._id} className="list-container">
                      <li>
                        <div className="input-container">
                          <div className="d-flex">
                            <input
                              name="status"
                              value={item?.name ? item?.name : ''}
                              // eslint-disable-next-line jsx-a11y/no-autofocus
                              autoFocus={!item?._id}
                              placeholder={t('DOCUMENT_TYPE.ENTER_STATUS')}
                              type="text"
                              disabled={!MasterAddEditAccess}
                              onChange={(e) => handleChanged(e, index)}
                            />
                          </div>
                          {checkDuplicate(item?.name) && !item?._id && item.name !== '' && (
                            <label htmlFor="entry" className="text-danger m-0 p-1">
                              {t('PLACEMENT_CARD_DRAG.ENTRY_ALREADY_EXIST')}
                            </label>
                          )}

                          {item.isEmpty && (item.name === null || item.name === '') && (
                            <label htmlFor="entry" className="text-danger m-0 p-1">
                              {t('DOCUMENT_TYPE.STATUS_REQUIRED')}
                            </label>
                          )}

                          {item?.name !== undefined && item?.name !== null && item?.name.trim().length === 0 && item?.name !== '' && (
                            <label htmlFor="entry" className="text-danger m-0 p-1">
                              {t('DOCUMENT_TYPE.INVALID_STATUS')}
                            </label>
                          )}
                        </div>
                        <div className="input-action">
                          {MasterAddEditAccess && item?._id !== '' && (
                            <div className={`status-color-container ${item?.isDefault && 'mr-4'}`}>
                              <span className={item?.statusColor ? item.statusColor + rountShape : rountShape} />
                              <div className="color-group">
                                <span onClick={() => handleStatusColor(index, 'red')} className="red rount-shape" />
                                <span onClick={() => handleStatusColor(index, 'amber')} className="amber rount-shape" />
                                <span onClick={() => handleStatusColor(index, 'green')} className="green rount-shape" />
                              </div>
                            </div>
                          )}
                          {MasterAddEditAccess && item?._id !== '' && !item?.isDefault && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 250, hide: 400 }}
                              overlay={(props) => renderTooltip(props, t('DOCUMENT_TYPE.ACTIVE/DEACTIVE'))}
                            >
                              <button onClick={() => activeAction(item?._id)} id={item?._id} type="button" aria-label={item?.isActive ? 'Active' : 'Inactive'}>
                                <span className={item?.isActive ? 'icon-active' : 'icon-inactive'} />
                              </button>
                            </OverlayTrigger>
                          )}

                          {MasterDeleteAccess && !item?.isDefault && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 250, hide: 400 }}
                              overlay={(props) => renderTooltip(props, t('DOCUMENT_TYPE.DELETE'))}
                            >
                              <button
                                type="button"
                                aria-label="Delete"
                                title={t('DOCUMENT_TYPE.DELETE')}
                                onClick={() => {
                                  deleteAction(item?._id ? item?._id : index);
                                }}
                              >
                                <span className="icon-delete mt-3 f-20" />
                              </button>
                            </OverlayTrigger>
                          )}
                        </div>
                      </li>
                    </div>
                  );
                })}{' '}
              </ul>
            </div>
          )}

          {MasterAddEditAccess && (
            <div className="section-save p-0">
              <button className="btn btn-page-filter btn-white" type="submit" onClick={handleClose} aria-label="Cancel">
                {t('DOCUMENT_TYPE.CANCEL')}
              </button>
              <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                <button
                  className="btn btn-page-filter btn-white"
                  type="submit"
                  onClick={handleClick}
                  disabled={statusCards?.length === 0 || isDisable()}
                  aria-label="Save"
                >
                  <span className="icon-Save c-button-align f-20 mr-2" />
                  {t('DOCUMENT_TYPE.SAVE')}
                </button>
              </CustomTooltip>
            </div>
          )}
        </Modal.Body>
      </Modal>
      {shouldShowDelete && (
        <ConfirmationPopup
          onOpen={shouldShowDelete}
          onConfirm={() => handleDelete()}
          title={t('DOCUMENT_TYPE.DELETE_TITLE')}
          message={t('DOCUMENT_TYPE.DELETE_MESSAGE')}
          toggle={() => {
            setShouldShowDelete((prev) => !prev);
          }}
          loading={isLoadingConf}
        />
      )}

      <ConfirmationPopup
        onOpen={showConfirmation}
        onConfirm={() => handleActiveInactive()}
        title={t('DOCUMENT_TYPE.ACTIVE/DEACTIVE')}
        message={t('DOCUMENT_TYPE.CONFIRMATION_MESSAGE')}
        toggle={() => {
          setShowConfirmation((prev) => !prev);
        }}
        loading={isLoadingConf}
      />
    </div>
  );
}
export default StatusSettings;
